import { render, staticRenderFns } from "./head-logistics.vue?vue&type=template&id=2784aa8e&scoped=true&"
import script from "./head-logistics.vue?vue&type=script&lang=js&"
export * from "./head-logistics.vue?vue&type=script&lang=js&"
import style0 from "./head-logistics.vue?vue&type=style&index=0&id=2784aa8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2784aa8e",
  null
  
)

export default component.exports